import React, { Component } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'

import Header from '../Header';
import Benefits from '../Benefits.js';
import { EMPLOYEE_CHECKRESTURL} from '../../constants/index';
import { getBenefits, getUrl } from '.././helper';

class EmployeeDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showError : false,
            staffID : '',
            benefitsProduct    : [],
        };
    }

    componentWillMount = () => {
        if(localStorage.getItem('hotelData')){
            const hotelData = JSON.parse(localStorage.getItem('hotelData'));
            this.setState({
                countryCode        : hotelData.CountryCode
            });
            this.setState({
                benefitsProduct: getBenefits(hotelData.CountryCode)
            })
        }else{
            window.location.href = "/ambassador";
        }

        if(localStorage.getItem('staffID')){
            const name = localStorage.getItem('staffID');
            this.setState({
                staffID        : name
            });
        }
    }



    handleNext = () => {
        const {staffID, hotelCode, countryCode} =this.state;
        const { state } = this.props.history.location;
        if(!staffID){
            this.setState({showError: true});
        }else{
            const urlRoot = getUrl().urlRoot;
            axios({
                method: "POST",
                url: EMPLOYEE_CHECKRESTURL,
                crossDomain : true,
                dataType: "json",
                contentType: "application/json",
                headers: {
                    'x-api-key': 'tIedQ6nwMS59qnGVS2vca6JlDN9SjLRz65NHYrr0'
                },
                data: {"employee_id": staffID},
            })
            .then(response => {
                console.log("response", response);
                //Go to next page
                if(response.data.status_text === "Active") {
                    console.log("url Go to next page");

                    var countryCodeRegion = countryCode.toLowerCase();

                    if(countryCodeRegion == 'cn' || countryCodeRegion == 'CN' || countryCodeRegion == 'mo' || countryCodeRegion == 'MO') {
                        countryCodeRegion = 'hk';
                    }

                    console.log('url', urlRoot + countryCodeRegion + "/registration/?hotelRIDOnlineKiosk="+state.hotelCode+"&apHotelEmployeeId="+staffID+"&redirect=F")
                    window.location.href = urlRoot + countryCodeRegion + "/registration/?hotelRIDOnlineKiosk="+state.hotelCode+"&apHotelEmployeeId="+staffID+"&redirect=F";
                } else {
                    console.log("Don't go to next page");
                    this.setState({showError: true});
                }
            })
            .catch(err => {
                console.log("fail", err);
            });
            // console.log('Redirection URL', urlRoot + countryCode.toLowerCase() +  "/registration?redirect=F&hotelRIDOnlineKiosk="+state.hotelCode+"&apHotelEmployeeId="+staffID);
        }
    };

    handleChange = (e) => {
        console.log(e);
        const key = e.target.name;
        const value = e.target.value;
        this.setState({ [key]: value });
    };

    render() {
        const { state } = this.props.history.location;
        const { showError, staffID } = this.state;
        return (
            <div className="hotelSales-wrapper">
                <Header 
                    showLeaderBoard   = {state.showLeaderBoard}
                    handleLeaderBoard = {this.leaderBoard}
                    bannerClass       = "ambassador"/>
                <div className="container mt-5">
                    <div>
                        <h4>Welcome to Accor Plus Loyalty Ambassador</h4>
                        <p>Before we get started, there are 3 short questions to ensure we have all the needed detail to successfully complete the transaction.</p>
                        <p>To assist the customer with the appropriate product selection, please see below our key membership benefits.</p>
                    </div>
                    <div>
                        <h4>Supplied details</h4>
                        <p><strong>Employee type: </strong>Loyalty Ambassador</p>
                        <p><strong>Hotel Details: </strong> {state.hotelName} -RID {state.hotelCode}</p>
                    </div>

                    <div>
                        <h4>Employee details <sup>*</sup></h4>
                        <p>Please provide your employee details for sales tracking</p>
                    </div>

                    <div className="hotel-code-container row">
                        <div className="form-group col-12 col-md-6">
                            <label for="staffID">Accor Plus Staff ID<sup>*</sup>
                            </label>
                            <input 
                                name        = "staffID"
                                type        = "text" 
                                placeholder = "Enter Accor Plus Staff ID"
                                className       = {`form-control ${showError ? ' border border-danger' : ''}`} 
                                value       = {staffID} 
                                onChange    = {this.handleChange} />
                            {showError && (
                                <div className="error">Not a valid code! Please try again.</div>
                            )}
                        </div>
                    </div>

                    <div className="mt-2">
                        <p>Why do we need this? Some sales will come with benefits for the staff member who made the sale. This information is used to ensure you get what you deserve :)</p>
                    </div>

                    <div className="d-flex justify-content-between">
                        <p class="disclaimer">*mandatory question</p>
                    </div>

                    <div className="d-flex justify-content-between">
                        <button className="btn btn-primary" onClick={()=> this.props.history.goBack()}><FontAwesomeIcon icon={faChevronLeft} /> BACK</button>
                        <button className="btn btn-primary" onClick={this.handleNext}>NEXT <FontAwesomeIcon icon={faChevronRight} /></button>
                    </div>
                </div>
            
                <Benefits 
                    data = {state.benefitResults}
                    benefitsProduct = {this.state.benefitsProduct}
                />
            </div>
        );
    }

}

export default EmployeeDetail;
